import { LangCodes } from '../interfaces';
import { getJson } from './jiraClient';


class UserApi {

    getLocale(): Promise<LangCodes> {
        return getJson('/mypreferences/locale').then(response => response.locale);
    }
}

export default new UserApi();
